interface LogoProps {
  className?: string
  size?: number
  showText?: boolean
}

export default function Logo({ className = '', size = 48, showText = false }: LogoProps) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src="/pet-halo-icon.png"
        alt="PetHalo"
        width={size}
        height={size}
        className="rounded-[22%]"
      />
      {showText && (
        <span className="text-2xl font-bold text-white tracking-tight">PetHalo</span>
      )}
    </div>
  )
}
